import { IMAGE_PLACE_HOLDER } from "@/constants";
export default {
  data() {
    return {
      placeholderImage: IMAGE_PLACE_HOLDER,
    };
  },
};
